var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEyeGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1896 5.35681C14.8516 2.53992 11.8091 0 8.25 0C4.24536 0 1.36682 3.13269 0.310425 5.35681C0.229858 5.52649 0.229858 5.72351 0.310425 5.89319C1.64844 8.71008 4.69092 11.25 8.25 11.25C12.2546 11.25 15.1332 8.11719 16.1896 5.89319C16.2701 5.72351 16.2701 5.52649 16.1896 5.35681ZM8.25 10C5.37061 10 2.98328 8.10242 1.58289 5.625C2.97742 3.15772 5.36328 1.25 8.25 1.25C11.1292 1.25 13.5167 3.14734 14.9171 5.625C13.5226 8.09216 11.1367 10 8.25 10ZM8.25 2.5C6.52686 2.5 5.125 3.90186 5.125 5.625C5.125 7.34815 6.52686 8.75 8.25 8.75C9.97314 8.75 11.375 7.34815 11.375 5.625C11.375 3.90186 9.97314 2.5 8.25 2.5ZM8.25 7.5C7.21619 7.5 6.375 6.65881 6.375 5.625C6.375 4.59107 7.21619 3.75 8.25 3.75C9.28394 3.75 10.125 4.59107 10.125 5.625C10.125 6.65881 9.28394 7.5 8.25 7.5Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeGrey);
export default __webpack_public_path__ + "static/media/icon-eye-grey.9c8d02275b237c28abfad32a1f278068.svg";
export { ForwardRef as ReactComponent };